<template>
  <section class="news-detail-section">
    <div v-if="isLoading">
      <base-info-bar>
        <router-link to="/devices-utilities/training-devices">{{ getMenuInfo.name}}</router-link>
        <span><img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png">
        >
        <img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png"></span>
        <router-link :to="getSubMenuInfo.url">{{ getSubMenuInfo.name }}</router-link>
        <span><img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png">
        >
        <img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png"></span>
        <router-link v-if="findNews" :to="findNews.url" style="color: black;">{{ findNews.title }}</router-link>
      </base-info-bar>
      <NewsDetail
        v-if="findNews"
        :entry="getSubMenuInfo.name"
        :createdAt="findNews.createdAt"
        :title="findNews.title"
        :content="findNews.description"
      ></NewsDetail>
    </div>
  </section>
</template>

<script>
import NewsDetail from '@/components/news-page/NewsDetail.vue'

export default {
  props: ['url'],
  components: {
    NewsDetail
  },
  data () {
    return {
      isLoading: false
    }
  },
  watch: {
    findNews: {
      immediate: true, // Run the watch handler immediately when the component is created
      handler (newValue) {
        if (!newValue && this.isLoading === true) {
          // If findNews is null or doesn't exist, redirect to NoInfoView
          this.$router.replace({ path: '/no-info' })
        }
      }
    },
    isLoading (newValue) {
      if (newValue && !this.findNews) {
        this.$router.replace({ path: '/no-info' })
      }
    }
  },
  computed: {
    getSubMenu () {
      if (this.$store.state.lang === 'vn') {
        return 14
      } else {
        return 33
      }
    },
    getMenuInfo () {
      return this.$store.getters['navbar/finalMenu'][3]
    },
    getSubMenuInfo () {
      return this.$store.getters['navbar/findSubMenus1'](this.getSubMenu)
    },
    findNews () {
      return this.$store.getters['news/getNewsDetail']
    }
  },
  async created () {
    this.isLoading = false
    await this.$store.dispatch('news/getNewsDetailByUrl', this.url)
    this.isLoading = true
  }
}
</script>

<style scoped>
.news-detail-section {
  min-height: 525px;
}

.news-detail-section a {
  text-decoration: none;
  color: rgb(28, 108, 193);
  font-weight: 700;
}

.news-detail-section span{
  font-weight: 800;
}

  @media (max-width: 1356px) {
    .news-detail-section {
      padding: 0 100px;
    }
  }

  @media (max-width: 1080px) {
    .news-detail-section {
      padding: 0 50px;
    }
  }

  @media (max-width: 720px) {
    .news-detail-section {
      padding: 0px 20px;
    }
  }
</style>
